const ErrorPage = () => {
  return <h3>Lo sentirmos, pagina no encontrada</h3>;
};

export default ErrorPage;
